import { render, staticRenderFns } from "./ShipmentProgress.vue?vue&type=template&id=91245852&scoped=true"
import script from "./ShipmentProgress.vue?vue&type=script&lang=js"
export * from "./ShipmentProgress.vue?vue&type=script&lang=js"
import style0 from "./ShipmentProgress.vue?vue&type=style&index=0&id=91245852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91245852",
  null
  
)

export default component.exports